var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-6"},[(_vm.$store.state.tasks.length)?_c('ListTasks'):_c('NoTasks'),_c('ButtonDoneSorting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }